<script setup lang="ts">
import config from '@/config';
import { useUserSession } from '@/store/userSession';

import AppMenuItem from './AppMenuItem.vue';

const store = useUserSession();

interface MenuItems {
  label: string;
  icon?: string;
  to?: string;
  class?: string;
  target?: string;
  permission?: string;
  items?: MenuItems[];
}

const model = ref<MenuItems[]>([
  {
    label: 'Home',
    items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' }],
    permission: 'view-dashboard',
  },
  {
    label: 'Department Management',
    icon: 'pi pi-fw pi-briefcase',
    items: [{ label: 'Department Management', icon: 'pi pi-building', to: '/department' }],
    permission: 'view-departments',
  },
  {
    label: 'Employee Management',
    items: [{ label: 'Employee Management', icon: 'pi pi pi-user', to: '/employees' }],
    permission: 'view-employee',
  },
  {
    label: 'Punch Management',
    icon: 'pi pi-fw pi-briefcase',
    items: [{ label: 'Punch Management', icon: 'pi pi pi-sign-out', to: '/punch-managment' }],
    permission: 'view-punch-in-out',
  },
  {
    label: 'Site Location Management',
    icon: 'pi pi-fw pi-briefcase',
    items: [{ label: 'Site Location Management', icon: 'pi pi pi-map-marker', to: '/sitelocation' }],
    permission: 'view-sitelocation',
  },
  {
    label: 'Role Management',
    items: [{ label: 'Role Management', icon: 'pi pi-shield', to: '/roles' }],
    permission: 'view-role',
  },
  // {
  //   label: 'Setting Management',
  //   items: [{ label: 'Role Management', icon: 'pi pi-cog', to: '/settings' }],
  //   permission: 'view-role',
  // },
  {
    label: 'Task Management',
    icon: 'pi pi-fw pi-briefcase',
    items: [{ label: 'Tasks Management', icon: 'pi pi-list-check', to: '/tasks' }],
    permission: 'view-task',
  },
  {
    label: 'Leave Management',
    icon: 'pi pi-fw pi-briefcase',
    items: [{ label: 'Leave Management', icon: 'pi pi-calendar-minus', to: '/leave' }],
    permission: 'request-leave',
  },
  {
    label: 'Approve Leave Management',
    icon: 'pi pi-fw pi-briefcase',
    items: [{ label: 'Approve Leave Management', icon: 'pi pi-sign-out', to: '/approve-leave-list' }],
    permission: 'approve-leave',
  },
  {
    label: 'Attendance Management',
    icon: 'pi pi-fw pi-briefcase',
    items: [{ label: 'Attendance Management', icon: 'pi pi-briefcase', to: '/attendance' }],
    permission: 'view-attendance',
  },
  {
    label: 'Working Day Management',
    icon: 'pi pi-fw pi-briefcase',
    items: [{ label: 'Working Days Management', icon: 'pi pi-calendar', to: '/workingdays' }],
    permission: 'view-workingdays',
  },
  // {
  //   label: 'Setting Management',
  //   icon: 'pi pi-fw pi-briefcase',
  //   items: [{ label: 'Setting Management', icon: 'pi pi-calendar', to: '/settings' }],
  //   permission: 'view-workingdays',
  // },
]);
</script>

<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in model" :key="item">
      <AppMenuItem v-if="!item.permission || store.user.permissions.includes(item.permission) || store.user.role === config.role.superAdmin" :item="item" :index="i" root parent-item-key="" />
    </template>
  </ul>
  <!-- <RouterLink to="/" class="layout-topbar-logo !block md:!hidden text-center ">
     <strong>Ashray
      <span>HRMS</span>
    </strong>
  </RouterLink> -->
</template>

<style lang="scss" scoped></style>
